/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AccountManagerListResponse } from './AccountManagerListResponse';

export type AccountManagerListResponseApiRespoonse = {
    data?: AccountManagerListResponse;
    status?: AccountManagerListResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AccountManagerListResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

